import React from 'react'
import { useTranslation } from 'react-i18next'
import { Accordion, AccordionDetails, AccordionSummary } from 'components/Shared/Accordion'
import styles from './OrderPointListItem.module.css'

export function OrderPointListItem ({ item, previousItem, defaultExpanded }) {
  const previousItemValue = previousItem?.value
  const { t } = useTranslation()

  function componentTypeChanged () {
    return previousItemValue?.getTitle(t) !== item?.getTitle(t)
  }

  function getTitle () {
    if (previousItem && componentTypeChanged()) {
      if (previousItemValue && item) {
        return `${previousItemValue.getTitle(t)} ${t('order.details.history.editHistory.replaced')} ${item.getTitle(t)}`
      } else if (item) {
        return `${t('order.details.history.editHistory.added')} ${item.getTitle(t)}`
      } else {
        return `${t('order.details.history.editHistory.removed')} ${previousItemValue.getTitle(t)}`
      }
    }
    return item.getTitle(t)
  }

  return (<Accordion defaultExpanded={defaultExpanded}>
    <AccordionSummary>
      <div className={styles.titleContainer}>
        <div className={styles.numberBox}>{item?.number || previousItemValue?.number}</div>
        <div className={styles.titleBox}>{getTitle()}</div>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      {!previousItem && item.renderContent()}
      {previousItem && (componentTypeChanged() ? (
          <div>
            {previousItemValue && (
              <div>
                {item && (
                  <div className={styles.listItemSubtitle}>{t('order.details.history.editHistory.beforeEdit')}</div>)}
                {previousItemValue.renderContent()}
              </div>
            )}
            {item && (
              <div>
                {previousItemValue && (
                  <div className={styles.listItemSubtitle}>{t('order.details.history.editHistory.afterEdit')}</div>)}
                {item.renderContent()}
              </div>
            )}
          </div>
        )
        : item.renderContent(previousItemValue.data))}
    </AccordionDetails>
  </Accordion>)
}
